<app-header-one [themeLogo]="themeLogo"></app-header-one>

<!-- Home slider start-->
<section class="p-0">
    <app-slider [sliders]="sliders" [textClass]="'text-center'" [category]="'watch'" [buttonText]="'Get Start'">
    </app-slider>
</section>
<!-- Home slider End -->

<!--  logo section start-->
<!-- <section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <app-logo [logos]="logos"></app-logo>
            </div>
        </div>
    </div>
</section> -->
<!--  logo section End-->

<!-- timer banner -->
<!-- <section>
    <div class="container">
        <div class="banner-timer" [ngStyle]="{'background-image': 'url(assets/images/about-banner-img02.jpg)'}">
            <div class="row">
                <div class="col-md-6">
                    <div class="banner-text">
                        <h2>Industry Leading Digital Solution Development
                          Services</h2>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="timer-box">
                        <div class="timer">
                            <p id="demo">
                              It Web Info  as a market leader delivers 360° digital solutions covering everything from custom app development services to web development, software development, and UI/UX design services.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- timer banner end -->

<!-- category -->
<section class="section-b-space">
    <div class="container">
        <div class="row">
          <h3 class="text-center">Our Formula For Your Business Success<span class="dot"></span> </h3>
<p>Our web & app development services are focused on making your business the next best in the market. Here’s our secret formula for delivering market-leading tech solutions.

</p>
            <div class="col">
                <app-collection [categories]="categories" [category]="'watch'"></app-collection>
            </div>
        </div>
    </div>
</section>
<!-- category end -->

  <section class="choose-us">
    <div class="container">

      <div class="row">
        <div class="col-md-12">
          <div class="heading">
            <h3 class="text-center">Why choose us<span class="dot"></span> </h3>

          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-md-6 col-lg-4">
          <div class="ch-box">
            <div class="absolut-container">
              <h3>Client First</h3>
              <div class="paragraph-wrapper">
                <p>
                  For any business, Clients are always at the core. Being a leading developer of web and mobile
                  applications, our concept
                  goes beyond our direct customers. We always start from where you are with your ideas and we think from
                  the viewpoints of
                  your end users, their areas of pain, and formulate a solution that solves key issues to help your
                  business.</p>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-6 col-lg-4">
          <div class="ch-box">
            <div class="absolut-container">
              <h3>
                Effective Synergy</h3>
              <div class="paragraph-wrapper">
                <p>Communication is to hear what isn’t being said. We appear at times to over-communicate. While it
                  sounds overwhelming, it
                  works wonders for our clients and our company ultimately. With communication alone we solve real-world
                  problems. Our
                  Development team remains in contact with customers through channels and media that allow performance,
                  transparency and
                  accuracy, feasible with all time zones across the World.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4">
          <div class="ch-box">
            <div class="absolut-container">
              <h3>
                On Time Delivery</h3>
              <div class="paragraph-wrapper">
                <p>We do not over promise we over-deliver our promise.<br>We have a great collection of internal
                  frameworks with best-in-class infrastructure with a decade of experience in the
                  IT software development industry that helps us to deliver solutions with superior quality at all
                  times. We have learned
                  how to avoid mistakes and repeat success all these years. We don’t brag about consistency alone. In
                  time, we describe
                  and produce it. Our Products are here to notify the same.</p>
              </div>
            </div>
          </div>
        </div>




        <div class="col-md-6 col-lg-4">
          <div class="ch-box">
            <div class="absolut-container">
              <h3>Strong Expertise</h3>
              <div class="paragraph-wrapper">
                <p>With our core field of expertise being Ruby on Rails, Angular, React, our coding experts remain on
                  the cutting edge of
                  the newest and most successful technology trends and popular applications on the market. So you can
                  expect a greater
                  level of ownership, commitments & deliveries in less time with higher quality while following all the
                  best practices for
                  the development. Thereby providing the best values for our customers. It is always that we believe in
                  Quality > Quantity
                  & “Value” is what is valued.</p>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-6 col-lg-4">
          <div class="ch-box">
            <div class="absolut-container">
              <h3>Total Ownership & Feedback Based</h3>
              <div class="paragraph-wrapper">
                <p>We do not follow the criteria or requirements just like that. Right from the beginning we have a
                  direct influence on the
                  project. We take spontaneous feedback from our clients, their customers, and other stakeholders that
                  have an impact on
                  the product. And we take your product and its feedback seriously. With this we make sure that we all
                  are heading towards
                  the right direction. Which saves really everything that matters.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4">
          <div class="ch-box">
            <div class="absolut-container">
              <h3>Results Focused</h3>
              <div class="paragraph-wrapper">
                <p>
                  We create digitally adaptable products, not just features. These are the real world problems and the
                  solutions are
                  futuristic. And we make sure we deliver them regardless of any factors that may hinder the development
                  or progress.
                  Everything is in control. You know your destination? We know how to take you there. In the long term,
                  our priority is on
                  making your company succeed.</p>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

  </section>

  <!-- <section class="Services">
    <div class="container">
      <div class="row">
        <div class="heading">
          <h3 class="text-center">Our Services<span class="dot"></span> </h3>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="servics-card">
            <div class="tabs">
              <div class="tab">
                <button class="tab-toggle active">Viable and Clean Design</button>
              </div>
              <div class="content active">
                <h3 class="heading">Viable and Clean Design</h3>
                <p class="description">When building a new website, you should take care of every component separately,
                  and consider even tiniest details, such
                  as layouts, spacing, graphics, white spaces, and so on. Information should simply run with a clear and
                  intuitive flow,
                  and every visitor should be presented with it in a concise way, free of whatever limitation or
                  navigation frustration.

                  The application process with 24/7 payday loans south africa was straightforward and I received the
                  funds I needed the
                  same day.</p>
              </div>

              <div class="tab">
                <button class="tab-toggle">Website Solutions</button>
              </div>
              <div class="content">
                <h3 class="heading">Website Solutions</h3>
                <p class="description">We are one of the renowned website Development Company and proficient in
                  ecommerce website development proved to be one of best website design firms. Our methods are user
                  friendly, agile, professional website design pattern and standard code architecture which offers
                  uniformity and is very open to any customization with very less effort.</p>
              </div>
              <div class="tab">
                <button class="tab-toggle">Mobile Application Solutions</button>
              </div>
              <div class="content">
                <h3 class="heading">Mobile Application Solutions</h3>
                <p class="description">Mobile Application is Need of an hour for any business entity. We focus on
                  powerful native, web, and hybrid mobile
                  applications for engaging mobility to your business. We offer custom web applications development
                  solutions and
                  compliance management services.</p>
              </div>
              <div class="tab">
                <button class="tab-toggle">Digital Marketing</button>
              </div>
              <div class="content">
                <h3 class="heading">Digital Marketing</h3>
                <p class="description">We have a vibrant digital marketing specialist. We at Aquila focus on every step
                  of business from conceptualization of
                  business, development and marketing the business. Looking for digital marketing firms to work exactly
                  like local SEO
                  services, we give that feel as our professionals are trained in such a way.

                  Every business needs brand recognition. We follow standard digital marketing packages and Social Media
                  Tools to give
                  your brand an organic traffic reach and effective online support.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </section> -->
  

  <section class="Technologies">
    <div class="container">
      <div class="row">
        <div class="heading">
          <h3 class="text-center">Technologies We Use<span class="dot"></span> </h3>

        </div>
      </div>

      <div class="ph-technology-new">
        <div class="container">

          <div class="row text-center">
            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Wordpress" src="/assets/images/tch3.png" class="img-fluid">
                <p>Wordpress</p>
              </div>
            </div>

            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                 <img alt="Blockchain" src="/assets/images/programing.png" class="img-fluid">
                <p>Angular
                </p>
              </div>
            </div>

            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/robot.png" class="img-fluid">
                <p>Android
                </p>
              </div>
            </div>

            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/apple1.png" class="img-fluid">
                <p>Apple
                </p>
              </div>
            </div> 
            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/flutter1.png" class="img-fluid">
                <p>Flutter
                </p>
              </div>
            </div> 
                    <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/tch8.png" class="img-fluid">
                <p>Android
                </p>
              </div>
            </div>         <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/images.png" class="img-fluid">
                <p>Codeginator
                </p>
              </div>
            </div>    
              <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/Laravel.png" class="img-fluid">
                <p>Laravel
                </p>
              </div>
            </div>             <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/nodejs.png" class="img-fluid">
                <p>Nodejs
                </p>
              </div>
            </div>         <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Illustrator" src="/assets/images/shopify1.png" class="img-fluid">
                <p>Shopify
                </p>
              </div>
            </div>
<!-- 
            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Photoshop" src="/assets/images/tch5.png" class="img-fluid">
                <p>Photoshop</p>
              </div>
            </div> -->

            <!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Html" src="/assets/images/tch6.png" class="img-fluid">
                <p>Html
                </p>
              </div>
            </div> -->

            <!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Ruby On Rails" src="/assets/images/apple.png" class="img-fluid">
                <p>apple
                </p>
              </div>
            </div> -->

            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="React" src="/assets/images/tch8.png" class="img-fluid">
                <p>React
                </p>
              </div>
            </div>

            <!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Salesforce" src="/assets/images/shopifys.png" class="img-fluid">
                <p>shopify</p>
              </div>
            </div> -->

            <!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="React" src="/assets/images/tch12.png" class="img-fluid">
                <p>Python
                </p>
              </div>
            </div> -->

            <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Salesforce" src="/assets/images/tch11.png" class="img-fluid">
                <p>PHP</p>
              </div>
            </div>

            
            <!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3">
              <div class="ph-technology-icon">
                <img alt="Salesforce" src="/assets/images/tch10.png" class="img-fluid">
                <p>Node Js</p>
              </div>
            </div> -->
            
           
          </div>
        </div>
      </div>

    </div>
  </section>

  <section class="roadmap">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 col-sm-12">
          <div class="ph-process-box">
            <h2 class="ph-color-white mb-3">Roadmap To Your <span>Mobile &amp; Web Development</span> Success</h2>
            <p>It Web Info offers top-quality results to clients at every stage of the product development process when
              starting
              fresh. We strive to make constant improvements at every stage to provide you with a smooth mobile &amp;
              web
              development service in USA that is error-free.
            </p>
            <div class="ph-process-btn">
              <a data-bs-toggle="modal"  [routerLink]="'/contact-us'" class="ph-btn remove-errors">Connect Now<i
                   class="fa-solid fa-arrow-right ms-2"></i></a>
            </div>
          </div>
        </div>


        <div class="col-md-6 col-sm-12">
          <div class="ph-process-img d-flex justify-content-end">
            <img alt="Development process" src="/assets/images/roadmap.svg" class="img-fluid">
          </div>
        </div>
      </div>

    </div>


  </section>

  <!-- <section class="design">

    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
          <div class="ph-heading-title text-start">
            <div class="ph-map-home">
              <div class="ph-small-heding">Guaranteed Customer Satisfaction
              </div>
              <h2 class="mb-3">We Develop, Design, Grow, and Prosper<span class="dot"></span>
              </h2>
              <p>With a team of skilled developers, It Web Info Technologies, a mobile &amp; web development company in
                USA, is
                ready to deliver outstanding outcomes for your project. We implement technologically advanced strategies
                to
                produce the ideal result.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 me-auto">
          <div class="ph-why-choose-grid" id="ph-counter-one">
            <ul class="mt-3">
              <li>
                <div class="ph-counter-icon">
                  <svg width="42" height="50" viewBox="0 0 42 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M40.7174 49.1991C40.8376 49.1991 40.9486 49.2175 41.0595 49.264V6.0957C40.9486 6.14175 40.8376 6.16061 40.7174 6.16061H31.5457C31.0186 7.81567 29.4841 8.97124 27.6996 8.97124H12.842C11.0575 8.97124 9.5227 7.81567 8.99593 6.16061H0.351275C0.231114 6.16061 0.110955 6.14219 0 6.0957V49.264C0.110952 49.2179 0.231114 49.1991 0.351275 49.1991H40.7174ZM26.1978 23.6917C26.2127 23.5417 26.2272 23.4207 26.2728 23.3005C26.318 23.1497 26.4079 23.015 26.5289 22.9093C26.6188 22.8335 26.7091 22.7734 26.8293 22.7282L31.4503 20.4557L26.8442 18.2274C26.7399 18.1822 26.6491 18.1221 26.5732 18.0765C26.4381 17.9713 26.3478 17.8362 26.2728 17.6704C26.2421 17.5503 26.2127 17.4143 26.1978 17.249V16.8131C26.1978 16.6328 26.1978 16.4811 26.2127 16.3767C26.2421 16.1956 26.2877 16.0605 26.3627 15.9395C26.4837 15.7741 26.7999 15.6242 27.0109 15.654C27.131 15.6698 27.2512 15.7141 27.3871 15.7899L34.3114 19.282C34.5066 19.3728 34.6583 19.5531 34.7478 19.8236C34.7929 19.989 34.8227 20.2157 34.8227 20.4709C34.8227 20.6069 34.8227 20.7121 34.8078 20.8165C34.7929 20.9375 34.7627 21.0275 34.7478 21.1033C34.7026 21.2542 34.6425 21.3743 34.5517 21.4647C34.5066 21.509 34.3408 21.63 34.2807 21.6598L27.3564 25.152C27.2214 25.2278 27.1003 25.2581 26.9802 25.2581H26.9508C26.7547 25.2581 26.4692 25.1072 26.3627 24.941C26.2877 24.8366 26.2425 24.7007 26.2127 24.5349C26.1978 24.4297 26.1978 24.2946 26.1978 24.1279L26.1978 23.6917ZM16.5954 27.3198L21.9097 12.7339C21.94 12.5979 22.015 12.4778 22.1049 12.3725C22.1956 12.2673 22.3009 12.1914 22.4368 12.1313C22.5421 12.0712 22.6772 12.0419 22.828 12.0269C23.0683 11.9962 23.4455 11.9962 23.6863 12.0419C23.8516 12.087 23.9875 12.1313 24.1077 12.2072C24.2735 12.3274 24.3932 12.5085 24.4388 12.7194C24.4691 12.8839 24.4537 13.0505 24.3787 13.2308L19.0495 27.847C19.0043 27.982 18.9442 28.118 18.8543 28.2083C18.7635 28.3285 18.6434 28.4035 18.4929 28.4636C18.3877 28.5087 18.282 28.5394 18.1469 28.5544C18.0408 28.5693 17.9057 28.5851 17.7549 28.5851C17.5597 28.5851 17.4089 28.5693 17.2733 28.5399C17.0931 28.4947 16.958 28.4346 16.837 28.3596C16.6716 28.2237 16.5515 28.0584 16.5208 27.8623C16.4761 27.6961 16.5059 27.5 16.5954 27.3198ZM6.257 20.1092C6.27191 19.9741 6.30217 19.8689 6.332 19.7636C6.37717 19.6728 6.42277 19.5825 6.46794 19.5075C6.54293 19.4167 6.72405 19.2672 6.84422 19.222L13.6935 15.7597C14.175 15.5342 14.521 15.7145 14.6864 15.9399C14.8074 16.121 14.8675 16.3771 14.8675 16.799C14.8675 16.9793 14.8526 17.1301 14.8526 17.2503C14.8377 17.4011 14.8074 17.5213 14.7767 17.6266C14.7315 17.7774 14.6416 17.9121 14.5206 18.0177C14.4456 18.0778 14.3553 18.1379 14.2496 18.1831L9.59919 20.4565L14.2044 22.6839C14.3255 22.7598 14.4163 22.805 14.4755 22.8501C14.5965 22.9545 14.7022 23.0755 14.7618 23.2413C14.807 23.3615 14.8377 23.4974 14.8526 23.6474C14.8526 23.7684 14.8675 23.9184 14.8675 24.0996C14.8675 24.2798 14.8526 24.4307 14.8381 24.5359C14.8224 24.7319 14.7623 24.8815 14.6719 25.003C14.5518 25.1529 14.2957 25.274 14.0847 25.274C14.0698 25.274 14.0553 25.274 14.0395 25.2591C13.9194 25.2433 13.7992 25.2139 13.6791 25.138L6.73954 21.631C6.5435 21.5402 6.40843 21.36 6.31809 21.0881C6.25801 20.9236 6.2431 20.7127 6.2431 20.4417C6.24222 20.3202 6.24222 20.2154 6.25713 20.1093M4.30344 32.0333H36.7613C36.9525 32.0333 37.1082 32.1885 37.1082 32.3802C37.1082 32.5714 36.953 32.727 36.7613 32.727H4.30344C4.11223 32.727 3.95655 32.5718 3.95655 32.3802C3.95699 32.1885 4.11223 32.0333 4.30344 32.0333ZM4.30344 38.6541H36.7613C36.9525 38.6541 37.1082 38.8093 37.1082 39.001C37.1082 39.1922 36.953 39.3478 36.7613 39.3478H4.30344C4.11223 39.3478 3.95655 39.1926 3.95655 39.001C3.95699 38.8093 4.11223 38.6541 4.30344 38.6541ZM4.30344 45.2749H36.7613C36.9525 45.2749 37.1082 45.4301 37.1082 45.6218C37.1082 45.813 36.953 45.9686 36.7613 45.9686H4.30344C4.11223 45.9686 3.95655 45.8134 3.95655 45.6218C3.95699 45.4301 4.11223 45.2749 4.30344 45.2749Z"
                      fill="#46464B"></path>
                    <path
                      d="M36.8253 0H4.24391C1.90648 0 0.00488281 1.89711 0.00488281 4.22982V5.12578C0.00488281 5.31698 0.160127 5.47266 0.351769 5.47266H9.53846C9.80027 7.06856 11.1926 8.27499 12.843 8.27499H27.7005C29.3499 8.27499 30.7432 7.06856 31.0051 5.47266H40.7185C40.9097 5.47266 41.0654 5.31742 41.0654 5.12578L41.065 4.22982C41.065 1.89722 39.163 0 36.8259 0M22.9417 5.39326H18.1208C17.9296 5.39326 17.7739 5.23801 17.7739 5.04637C17.7739 4.85517 17.9292 4.69948 18.1208 4.69948H22.9417C23.1329 4.69948 23.2886 4.85473 23.2886 5.04637C23.2886 5.23757 23.1334 5.39326 22.9417 5.39326Z"
                      fill="#46464B"></path>
                    <path
                      d="M40.7139 49.8965H0.347863C0.156659 49.8965 0.000976562 50.0517 0.000976562 50.2434V55.7603C0.000976562 58.0978 1.90258 59.9994 4.24 59.9994H36.8214C39.1588 59.9994 41.0604 58.0974 41.0604 55.7603V50.2434C41.0608 50.0517 40.9056 49.8965 40.7139 49.8965ZM22.8891 56.1168C22.8891 56.7733 22.362 57.3097 21.7055 57.3097H19.3571C18.7005 57.3097 18.1734 56.7733 18.1734 56.1168V53.7776C18.1734 53.1119 18.7005 52.5847 19.3571 52.5847H21.7055C22.362 52.5847 22.8891 53.1119 22.8891 53.7776V56.1168Z"
                      fill="#46464B"></path>
                  </svg>
                </div>
                <h2 class="ph-counter-value" data-count="430">430</h2><span> +</span>
                <h3>Apps Developed</h3>
              </li>
              <li>
                <div class="ph-counter-icon">
                  <svg width="79" height="52" viewBox="0 0 79 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M45.9149 56.5293C45.7242 57.0584 45.203 57.3974 44.5824 57.3974H30.0545C29.434 57.3974 28.9134 57.059 28.722 56.5293H0V57.3956C0 58.9218 1.23801 60.0006 2.76419 60.0006H71.8735C73.3996 60.0006 74.6377 58.9218 74.6377 57.3956V56.5293H45.9149Z"
                      fill="#46464B"></path>
                    <path d="M19.9609 24.4141H41.6578V26.1497H19.9609V24.4141Z" fill="#46464B"></path>
                    <path d="M19.9609 21.8125H39.9221V23.5481H19.9609V21.8125Z" fill="#46464B"></path>
                    <path d="M19.9609 27.0195H38.1863V28.7551H19.9609V27.0195Z" fill="#46464B"></path>
                    <path
                      d="M78.1415 2.09508C78.4036 1.83295 78.4036 1.40797 78.1415 1.14584L77.1922 0.196597C76.9301 -0.0655324 76.5051 -0.0655324 76.243 0.196597L53.4612 21.0783C53.1991 21.3404 53.1991 21.7654 53.4612 22.0276L56.309 24.8753C56.5711 25.1374 56.9961 25.1374 57.2582 24.8753L78.1415 2.09508Z"
                      fill="#46464B"></path>
                    <path
                      d="M45.5875 34.3599C46.8763 33.7158 47.182 34.7988 47.182 34.7988C47.182 34.7988 52.194 31.6097 54.9278 26.1419C54.0167 25.2308 53.5609 24.775 53.5609 24.775C53.5609 24.775 52.947 24.1611 52.0359 23.25C46.5681 25.984 43.399 31.0158 43.399 31.0158C43.399 31.0158 44.5032 31.3415 43.8579 32.6297C43.2138 33.9186 40.2686 32.4415 38.9017 35.6306C37.7666 38.2791 36.2471 42.0882 36.2471 42.0882C36.2471 42.0882 39.9774 40.4894 42.626 39.3542C45.8157 37.9879 44.2986 35.0046 45.5874 34.3597L45.5875 34.3599ZM40.8255 37.5109C40.3345 37.02 40.3345 36.2233 40.8255 35.7318C41.3164 35.2408 42.1131 35.2408 42.6046 35.7318C43.0956 36.2227 43.0956 37.0194 42.6046 37.5109C42.1136 38.0031 41.317 38.0031 40.8255 37.5109Z"
                      fill="#46464B"></path>
                    <path
                      d="M66.7063 17.058C66.7753 17.1828 66.8256 17.319 66.8256 17.4727V50.452C66.8256 50.9309 66.4369 51.3202 65.9575 51.3202L8.67764 51.3195C8.19879 51.3195 7.80952 50.9309 7.80952 50.4514L7.81012 17.4721C7.81012 16.9933 8.19878 16.604 8.67825 16.604H55.8504L59.6378 13.1328H7.81006C6.07446 13.1328 4.33887 13.1328 4.33887 14.8684V54.7907H70.2975L70.2968 14.8684C70.2968 14.0172 70.2944 13.5868 70.0892 13.3652L66.7063 17.058Z"
                      fill="#46464B"></path>
                    <path
                      d="M48.1141 36.265L46.4341 37.3341C46.2216 38.2034 45.7851 39.2059 44.8002 40.0395H56.4114V41.7751H41.3894L36.9313 43.6863L35.5825 44.2638V46.1144H19.9608V38.3038H35.5825V39.0999C36.1026 37.8226 36.7515 36.2443 37.3073 34.9501C37.3255 34.9077 37.3472 34.8744 37.3654 34.8326L9.54688 34.832V49.5858H65.091V34.832H50.0266C48.9563 35.7201 48.196 36.2129 48.1148 36.265L48.1141 36.265ZM49.4683 44.3788H39.922V42.6432H49.4689L49.4683 44.3788Z"
                      fill="#46464B"></path>
                  </svg>
                </div>
                <h2 class="ph-counter-value" data-count="680">680</h2><span> +</span>
                <h3>Websites Designed</h3>
              </li>
              <li>
                <div class="ph-counter-icon">
                  <svg width="84" height="50" viewBox="0 0 84 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M78.7068 1.47464C78.7098 1.08442 78.5559 0.709177 78.2813 0.432261C78.0066 0.156094 77.6329 0 77.2426 0H77.2404L5.81552 0.0855517C5.00579 0.0863021 4.34989 0.742202 4.34839 1.55118V42.0147H78.7069L78.7068 1.47464ZM36.7544 11.2387C36.8287 11.0106 37.0261 10.844 37.2632 10.8102L39.7757 10.4455L40.8991 8.16856H40.8999C41.0177 7.96893 41.2331 7.84586 41.465 7.84586C41.6976 7.84586 41.9122 7.96893 42.0308 8.16856L43.1542 10.4455L45.6675 10.8102C45.9054 10.8448 46.1028 11.0106 46.1771 11.2387C46.2513 11.4676 46.1891 11.7175 46.0172 11.8856L44.1981 13.659L44.6274 16.1624L44.6281 16.1617C44.6596 16.3448 44.6086 16.5324 44.4885 16.675C44.3692 16.8168 44.1921 16.8986 44.0067 16.8986C43.9047 16.8986 43.8041 16.8739 43.7133 16.8266L41.465 15.6446L39.2167 16.8266H39.2174C39.0043 16.9354 38.7491 16.9166 38.554 16.7793C38.3597 16.6375 38.2621 16.3981 38.3026 16.1617L38.7319 13.6582L36.9135 11.8849L36.9143 11.8857C36.7424 11.7176 36.6801 11.4669 36.7544 11.2387ZM32.3936 16.7794C32.1999 16.9197 31.9425 16.9377 31.7309 16.8267L29.4818 15.6447L27.2335 16.8267C27.0203 16.9355 26.7652 16.9167 26.5701 16.7794C26.3757 16.6375 26.2789 16.3989 26.3187 16.1618L26.7487 13.6583L24.9296 11.885L24.9303 11.8857C24.7585 11.7176 24.6962 11.4677 24.7705 11.2388C24.8448 11.0107 25.0422 10.8448 25.28 10.8103L27.7925 10.4456L28.916 8.16864C29.0345 7.96901 29.2492 7.84594 29.4818 7.84594C29.7137 7.84594 29.9291 7.96901 30.0469 8.16864L31.1703 10.4456L33.6836 10.8103H33.6843C33.9215 10.8448 34.1189 11.0107 34.1931 11.2388C34.2674 11.4677 34.2059 11.7176 34.034 11.8857L32.2149 13.659L32.645 16.1625V16.1618C32.6855 16.3989 32.5879 16.6376 32.3936 16.7794ZM48.0068 36.4636H48.0076C48.0076 34.144 46.7701 32.0007 44.7612 30.8411C42.7522 29.6809 40.2772 29.6809 38.2683 30.8411C36.2593 32.0006 35.0219 34.1438 35.0219 36.4636H33.7611C33.7671 34.8531 34.2744 33.2839 35.214 31.9759C36.1536 30.6671 37.4773 29.684 39.0016 29.1639C37.9824 28.4472 37.3183 27.3298 37.175 26.0924C37.0324 24.8549 37.4249 23.615 38.2534 22.6846C39.0826 21.7548 40.269 21.2227 41.5149 21.2227C42.7608 21.2227 43.9471 21.7548 44.7765 22.6846C45.605 23.6152 45.9975 24.855 45.8549 26.0924C45.7115 27.3299 45.0474 28.4473 44.0283 29.1639C45.5524 29.684 46.8762 30.6671 47.8158 31.9759C48.7554 33.284 49.2627 34.8533 49.2687 36.4636H48.0068ZM58.126 11.8862L56.3068 13.6595L56.7361 16.163L56.7369 16.1622C56.7684 16.3453 56.7174 16.5337 56.5973 16.6755C56.478 16.8174 56.3008 16.8999 56.1155 16.8992C56.0134 16.8992 55.9129 16.8744 55.8221 16.8271L53.5737 15.6452L51.3254 16.8271H51.3262C51.113 16.9359 50.8579 16.9172 50.6628 16.7799C50.4684 16.638 50.3708 16.3994 50.4114 16.1622L50.8406 13.6588L49.0215 11.8854L49.0223 11.8862C48.8504 11.7181 48.7881 11.4682 48.8624 11.2393C48.9367 11.0112 49.1341 10.8453 49.372 10.8108L51.8852 10.4461L53.0087 8.16912C53.1265 7.96949 53.3419 7.84642 53.5745 7.84642C53.8064 7.84642 54.0218 7.96949 54.1396 8.16912L55.263 10.4461L57.7763 10.8108H57.777C58.0142 10.8453 58.2115 11.0112 58.2858 11.2393C58.3601 11.4682 58.2978 11.7181 58.126 11.8862ZM54.7541 11.646L56.3308 11.8742L55.1901 12.9871C55.0415 13.1319 54.9733 13.3413 55.0085 13.5454L55.2779 15.1161L53.8671 14.3739V14.3747C53.6832 14.2786 53.4641 14.2786 53.281 14.3747L51.8701 15.1169L52.1395 13.5462V13.5454C52.1748 13.3413 52.1065 13.1319 51.9579 12.9871L50.8172 11.8742L52.3939 11.646C52.5988 11.616 52.7766 11.4877 52.8689 11.3016L53.5744 9.87346L54.2798 11.3016H54.2791C54.3714 11.4877 54.5492 11.616 54.7541 11.646ZM44.6223 25.6036C44.6223 26.4276 44.2951 27.2179 43.712 27.8011C43.1289 28.3834 42.3387 28.7106 41.5146 28.7106C40.6905 28.7106 39.8996 28.3834 39.3172 27.8003C38.7341 27.218 38.4069 26.4277 38.4069 25.6029C38.4069 24.7789 38.7341 23.9887 39.3172 23.4055C39.9003 22.8231 40.6905 22.4952 41.5146 22.4952C42.3386 22.4967 43.1288 22.8239 43.7112 23.407C44.2936 23.9893 44.6216 24.7796 44.6223 25.6036ZM39.8494 12.9878L38.7087 11.8748L40.2854 11.6467V11.646C40.4903 11.6167 40.6681 11.4876 40.7604 11.3015L41.4659 9.87338L42.1713 11.3015H42.1705C42.2629 11.4876 42.4407 11.6167 42.6456 11.646L44.2223 11.8741L43.0816 12.987V12.9878C42.933 13.1319 42.8647 13.3412 42.9 13.5454L43.1694 15.1161L41.7585 14.3739V14.3746C41.5747 14.2785 41.3555 14.2785 41.1724 14.3746L39.7616 15.1168L40.031 13.5461V13.5454C40.0662 13.3412 39.9979 13.1319 39.8494 12.987L39.8494 12.9878ZM32.2391 11.8741L31.0984 12.987L31.0977 12.9878C30.9491 13.1319 30.8808 13.3412 30.9161 13.5454L31.1862 15.1161L29.7746 14.3739V14.3746C29.5915 14.2785 29.3723 14.2785 29.1885 14.3746L27.7776 15.1168L28.0478 13.5461V13.5454C28.083 13.3412 28.0148 13.1319 27.8662 12.9878L26.7255 11.8748L28.3014 11.6467V11.646C28.507 11.6167 28.6842 11.4876 28.7765 11.3015L29.4819 9.87338L30.1873 11.3015H30.1866C30.2789 11.4876 30.4567 11.6167 30.6616 11.646L32.2391 11.8741ZM28.6594 48.3281H4.34905V43.2768H78.7075V48.3281H54.3703V48.3048H28.6594V48.3281ZM54.3703 49.5889H83.0301V52.9494C83.0294 53.5294 82.5596 53.9992 81.9795 54H1.05064C0.470549 53.9993 0.000768464 53.5295 0 52.9494V49.5889H28.6599V52.4257H54.3707L54.3703 49.5889ZM29.9197 51.1648V49.5889H53.1081V51.1648H29.9197Z"
                      fill="#46464B"></path>
                  </svg>
                </div>
                <h2 class="ph-counter-value" data-count="175">175</h2><span> +</span>
                <h3>Happy Clients</h3>
              </li>
              <li>
                <div class="ph-counter-icon">
                  <svg width="70" height="45" viewBox="0 0 72 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M35.9716 24.1995C45.0385 24.1995 52.3898 37.8727 52.3898 43.6646C52.3898 57.4451 19.5521 57.4451 19.5521 43.6646C19.5521 37.872 26.9011 24.1995 35.9703 24.1995H35.9716ZM14.8846 0C19.6769 0 23.5628 3.88383 23.5628 8.67816C23.5628 13.4704 19.679 17.3563 14.8846 17.3563C10.0924 17.3563 6.20648 13.4703 6.20648 8.67816C6.20648 3.88602 10.0903 0 14.8846 0ZM57.0573 0C61.8495 0 65.7354 3.88383 65.7354 8.67816C65.7354 13.4704 61.8516 17.3563 57.0573 17.3563C52.265 17.3563 48.3791 13.4703 48.3791 8.67816C48.3791 3.88602 52.2629 0 57.0573 0ZM57.0573 21.9425C65.2783 21.9425 71.9452 34.3392 71.9452 39.5912C71.9452 46.3286 63.2921 49.4307 55.3148 48.904C56.0645 47.354 56.49 45.6089 56.49 43.6658C56.49 38.7933 53.3719 32.642 50.5113 28.8244C49.8879 27.9941 49.2142 27.1782 48.4924 26.3986C50.9139 23.8092 53.8685 21.9421 57.0583 21.9421L57.0573 21.9425ZM14.8846 21.9425C18.074 21.9425 21.0291 23.8096 23.4528 26.399C22.731 27.1764 22.0568 27.9923 21.4338 28.8226C18.5734 32.6397 15.4551 38.791 15.4551 43.664C15.4551 45.607 15.8781 47.3527 16.6303 48.9022C8.65311 49.431 0 46.3268 0 39.5894C0 34.3373 6.66418 21.9407 14.8879 21.9407L14.8846 21.9425ZM35.9716 0C41.2584 0 45.5422 4.28378 45.5422 9.57059C45.5422 14.8547 41.2584 19.1412 35.9716 19.1412C30.6848 19.1412 26.4011 14.8574 26.4011 9.57059C26.4011 4.28378 30.6848 0 35.9716 0Z"
                      fill="#46464B"></path>
                  </svg>
                </div>
                <h2 class="ph-counter-value" data-count="220">220</h2><span> +</span>
                <h3>Team Strength</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


  </section> -->


<!--  tab section  -->

<!--  tab section end -->

<!-- product section -->
<!-- product section end -->


<!-- blog section start-->
<!-- <section class="blog blog-bg section-b-space">
    <div class="container">
        <div class="title4">
            <h2 class="title-inner4">Recent Story</h2>
            <div class="line">
                <span></span>
            </div>      
        </div>
        <div class="row">
            <div class="col-md-12">
                <app-blog [blogs]="blogs"></app-blog>
            </div>
        </div>
    </div>
</section> -->
<!-- blog section end -->

<!-- services start-->
<!-- <div class="container section-t-space section-b-space">
    <section class="service border-section small-section">
        <app-services></app-services>
    </section>
</div> -->
<!-- services End -->


<!-- Cart Open To Left Side-->
<app-cart-variation [direction]="'left'"></app-cart-variation>
<app-footer-one [themeLogo]="themeLogo"></app-footer-one>
  <script src="/assets/html/js/jquery.min.js"></script>
<script>
  // ----------------- Variables

  wrapper = $(".tabs"); 
  tabs = wrapper.find(".tab");
  tabToggle = wrapper.find(".tab-toggle");

  // ----------------- Functions

  function openTab() {
    var content = $(this).parent().next(".content"),
      activeItems = wrapper.find(".active");

    if (!$(this).hasClass('active')) {
      $(this).add(content).add(activeItems).toggleClass('active');
      wrapper.css('min-height', content.outerHeight());
    }
  };

  // ----------------- Interactions

  tabToggle.on('click', openTab);

  // ----------------- Constructor functions

  $(window).load(function () {
    tabToggle.first().trigger('click');
  });

</script>